export const REQUEST_DASHBOARD_V2 = 'zola/dashboard/REQUEST_DASHBOARD_V2';
export const RECEIVE_DASHBOARD_V2 = 'zola/dashboard/RECEIVE_DASHBOARD_V2';



// WEBPACK FOOTER //
// ./src/actions/types/DashboardActionTypesV2.js